import { render, staticRenderFns } from "./galleryMobile.vue?vue&type=template&id=40813f04&scoped=true"
import script from "./galleryMobile.vue?vue&type=script&lang=js"
export * from "./galleryMobile.vue?vue&type=script&lang=js"
import style0 from "./galleryMobile.vue?vue&type=style&index=0&id=40813f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40813f04",
  null
  
)

export default component.exports